<template>
  <div class="student-container">
    <el-input
      style="width: 200px; margin-right: 20px"
      v-model="search.name"
      placeholder="操作人員"
      size="small"
    ></el-input>
    <el-date-picker
      v-model="search.time"
      type="daterange"
      :clearable="false"
      range-separator="-"
      :start-placeholder="$t('app.startSearchDate')"
      :end-placeholder="$t('app.endSearchDate')"
      size="small"
      style="margin-right: 20px"
    >
    </el-date-picker>
    <el-input
      style="width: 350px; margin-right: 20px"
      v-model="search.content"
      placeholder="日誌內容"
      size="small"
    ></el-input>
    <el-button type="primary" @click="reset" size="small">重置</el-button>
    <el-button
      type="success"
      icon="el-icon-search"
      @click="getList"
      size="small"
      >查詢</el-button
    >
    <el-table :data="tableData" stripe style="width: 100%" height="650">
      <el-table-column label="操作人員" prop="LOGIN_NAME" width="200" />
      <el-table-column label="操作時間" prop="OPERATION_TIME" />
      <el-table-column label="操作內容" prop="CONTENT" />
      <el-table-column label="Url" prop="URL" />
    </el-table>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
    <info ref="infoModal" @handleSuccess="updList"></info>
  </div>
</template>

<script>
import { Group } from "@/api/systemManagement/log";
import { delEmpty } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      loading: false,
      size: 10,
      currentPage: 1,
      total: 100,
      deleteItem: "",
      deleteIndex: "",
      tableData: [],
      search: {
        name: "",
        time: [],
        content: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleEdit(index, row) {
      this.$refs.infoModal.edit(index, row);
    },
    reset() {
      this.search = {
        name: "",
        time: [],
        content: "",
      };
    },
    getList() {
      Group(
        delEmpty({
          LoginUser: this.search.name,
          Content: this.search.content,
          BeginTime: this.search.time[0] || "",
          EndTime: this.search.time[1] || "",
          PageIndex: this.currentPage,
          PageSize: this.size,
        })
      ).then((res) => {
        if (res.data != undefined || res.data != null) {
          this.total = res.data.Total;
          this.tableData = res.data.Items;
        }
      });
    },
    updList(index, row) {
      this.tableData.splice(index, 1, row);
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.student-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
}
</style>
